$(->
  $(document).on 'change', '.file.form-group input', ->
    filename = $(this).val().replace(/^.*[\\\/]/, '')
    $(this).closest('fieldset').find('.file_name').val(filename)
    $(this).closest('form').find('input[type="submit"]').prop('disabled', false)

  $('.orig-photo img').on 'error', ->
    $(this).parent().append('<i class="fa fa-picture-o"></i>')
    $(this).remove()
)
